(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('ContactReportFactory', ContactReportFactory);

    //** NgInject */
    function ContactReportFactory($resource) {
        var resourceUrl = '';

        return $resource(resourceUrl, {}, {

            'listUsersRegisteredByGenderWithContactGeneratedByStore': {
                method: 'POST',
                isArray: true,
                url: '/flyer/api/contact/report/users-by-gender',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listMostLikedCategories': {
                method: 'POST',
                url: '/flyer/api/contact/report/most-liked-categories',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listUsersGenerateMoreContact': {
                method: 'POST',
                isArray: true,
                url: '/flyer/api/contact/report/users-generate-more-contacts',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listUsersFirstInteraction': {
                method: 'POST',
                isArray: true,
                url: '/flyer/api/contact/report/users-first-interaction',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }

        });
    }

})();
